var bighouse = bighouse || {};

bighouse.nav = (function () {
    function init() {
        bindDropdowns();
    }

    function bindDropdowns() {
        $('.js-navDropdownToggle').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var thisParent = $(this).closest('.js-navHasDropdown');
            var bIsOpen = thisParent.hasClass('Nav-showDropdown');
            var megaMenu = $(this).attr('data-menuid');

            if (bIsOpen) {
                close();
            } else {
                // Close others
                close(thisParent.siblings('.Nav-showDropdown'));
                open(thisParent);
                openMegaMenu(megaMenu);
            }
        });

        $(document).on('click', function (e) {
            if (
                !$(e.target).closest('.js-navDropdownToggle').length &&
                !$(e.target).closest('.LocationsMenu').length
            ) {
                close();
            }
        });
    }

    function open(thisParent) {
        $(thisParent).addClass('Nav-showDropdown');
        $('.Header').addClass('Header--openMenu');
        bighouse.header.homepageClass();
    }

    function openMegaMenu(megaMenu) {
        $('.' + megaMenu).addClass('js-Megamenu--open');
    }

    function close(thisParent) {
        if (thisParent) {
            $(thisParent).removeClass('Nav-showDropdown');
        } else {
            $('.Nav-showDropdown').removeClass('Nav-showDropdown');
        }

        $('.js-Megamenu--open').removeClass('js-Megamenu--open');
        $('.Header').removeClass('Header--openMenu');
        bighouse.header.homepageClass();
    }

    return {
        init: init,
        close: close
    };
})();